module.exports = __webpack_public_path__ + "img/19_42.3d9b7cdf.png";